<template>
  <div class="compliance-root py-16">
    <FormattedHeader
      header="Areas of Compliance & Potential Risks"
      :subheader="subtitle"
      class="max-w-3xl mx-auto mb-16 px-8"
    />

    <div class="flex flex-wrap justify-center max-w-5xl mx-auto mb-20">
      <SeoBlock
        v-for="(box, index) in ComplianceBoxes"
        :key="`compliance-box-${index}`"
        v-bind="box"
        class="m-2"
      ></SeoBlock>
    </div>
    <Ribbon />
    <WhatYouGet class="lg:max-w-4xl mx-auto mb-10" />
    <RegistrationPrompt
      button-id="company-size-button"
      class="mx-auto shadow-md"
    />
  </div>
</template>
<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import SeoBlock from '@/components/SeoBlock.vue';
import FormattedHeader from '@/components/FormattedHeader.vue';
import Ribbon from '@/components/Ribbon';
import WhatYouGet from '@/components/WhatYouGet.vue';
import RegistrationPrompt from '@/components/RegistrationPrompt';

import { ComplianceBoxes } from '@/modules/InformationPages/Compliance/mocks/index.js';
import useMatchMedia from '@/hooks/useMatchMedia';
import useGlobalSettings from '@/hooks/useGlobalSettings';

export default defineComponent({
  name: 'ComplianceRoot',
  components: {
    FormattedHeader,
    RegistrationPrompt,
    Ribbon,
    SeoBlock,
    WhatYouGet,
  },
  setup() {
    const { setHeader } = useGlobalSettings();
    const matchMedia = useMatchMedia();
    const heroBg = `assets/information/compliance/compliance-hero.jpg`;
    const heroTitle = `Bambee will create and maintain HR labor policies that keep you in line with State and Federal regulations`;
    const heroSubTitle = `We’ll make understanding State and Federal Labor regulations easy. Then ensure your business is compliant by creating policies, procedures, and documents customized for your company.`;
    const subtitle = `Bambee helps small businesses of every kind comply with State and Federal regulations. Here are the rules you need to know, and the risks we can help you avoid.`;

    setHeader({
      header: heroTitle,
      subheader: heroSubTitle,
      heroImage: heroBg,
      metaTitle: heroTitle,
      registration: false,
      noHero: false,
    });

    useMeta(() => ({ title: heroTitle }));

    return {
      matchMedia,
      heroBg,
      heroTitle,
      heroSubTitle,
      subtitle,
      ComplianceBoxes,
    };
  },
  head() {},
});
</script>
